export default {
  disableServiceTitle: "أنت على وشك تعطيل {{service}} في فرع {{branch}}",
  disableServiceSubtitle:
    "يرجى تحديد سبب هذا الإجراء. سيتم تسجيله في سجل إجراءات العلامة التجارية.",
  scheduledDisableTitle: "تعديل التعطيل المجدول",
  scheduledDisableSubtitle: "تحديث التعطيل المجدول لفرع {{branch}}.",
  reasonLabel: "السبب",
  reasonRequired: "يرجى اختيار سبب",
  customDateRequired: "يرجى اختيار التاريخ والوقت",
  durationLabel: "مدة الإيقاف",
  autoResumeLabel: "سيتم تفعيل {{service}} تلقائيًا خلال",
  autoResumeOnDateLabel: "سيتم تفعيل {{service}} تلقائيًا في {{date}}",
  duration_1h: "ساعة واحدة",
  duration_2h: "ساعتان",
  duration_1d: "يوم واحد",
  duration_1w: "أسبوع واحد",
  duration_1m: "شهر واحد",
  duration_custom: "تاريخ/وقت مخصص",
  duration_permanent: "بدون تاريخ انتهاء",
  reasonSelectPlaceholder: "اختر سببًا",
  reasonPosIssue: "مشكلة في نظام نقاط البيع (POS)",
  reasonStaffShortage: "نقص في الموظفين",
  reasonRamadanHours: "ساعات عمل رمضان",
  reasonMaintenance: "صيانة",
  reasonBrandRequest: "بناءً على طلب العلامة التجارية",
  reasonOther: "سبب اَخر - يرجى التحديد",
  specifyReasonPlaceholder: "حدد السبب",
  cancel: "إلغاء",
  apply: "تطبيق",
  save: "حفظ",
  confirmDisable: "تأكيد التعطيل",
  enable: "تفعيل",
  updateScheduled: "تحديث الإجراء المجدول",
  pickup: "الاستلام",
  delivery: "خدمة التوصيل",
  driveThru: "الدرايف ثرو",
  offlineLoyalty: "حالة نظام الولاء من خلال المطعم",
  onlineLoyalty: "حالة نظام الولاء من خلال كوينز",
  scheduledDisableTooltip: "هذا الفرع مجدول للتعطيل",
  badgeUntilLabel: "حتى {{date}}",
  badgePermanentLabel: "دائم",
  badgeReasonLabel: "السبب: {{reason}}",
  badgeDurationLabel: "مدة الإيقاف: {{duration}}",
};
